const timings = {
  short: 0.1,
  medium: 0.25,
  long: 0.4,
}

module.exports = {
  short: `all ${timings.short}s ease-in-out`,
  medium: `all ${timings.medium}s ease-in-out`,
  long: `all ${timings.long}s ease-in-out`,
}
